import * as React from "react";
import { Row, Col } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { generateUId } from "../../utils/generateUId";
import { ReceiverCheckbox } from "./ReceiverCheckbox";
import { IconPrefix, IconName } from "@fortawesome/fontawesome-svg-core";
import { formatUsername } from "utils/formatUsername";

interface ContactsModalItemProps {
  state: { [key: string]: string[] | string };
  data: API_Contact & API_User;
  onCheckboxChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const ContactsModalItem = ({ state, data, onCheckboxChange }: ContactsModalItemProps) => {
  const { email, name, contactType, firstName, surname } = data;
  const uid = generateUId(data);
  const config: { [key in API_CONTACT_CONTACTTYPE]?: [IconPrefix, IconName] } = {
    PUBLIC: ["fas", "globe"],
    PRIVATE: ["fas", "lock"],
  };

  return (
    <Row key={name} className="modal-item" justify="space-between" align="middle">
      <Col xs={2} className="avatar">
        <FontAwesomeIcon icon={["fas", "user-alt"]} fixedWidth={true} className="icon" />
        {config[contactType] && (
          <span className="avatar-lock">
            <FontAwesomeIcon icon={config[contactType]} fixedWidth={true} className="icon" />
          </span>
        )}
      </Col>
      <Col xs={14}>
        {" "}
        {formatUsername({ firstName, surname })} / {email}{" "}
      </Col>
      <Col xs={7}>
        <div className="checkbox-cc-bcc">
          {["to", "cc", "bcc"].map((type) => {
            return (
              <ReceiverCheckbox
                key={type}
                checked={!!state[type] && !!state[type].includes(uid)}
                type={type}
                value={uid}
                onChange={onCheckboxChange}
              />
            );
          })}
        </div>
      </Col>
    </Row>
  );
};
